import { SYSLOGS_API } from "../../../../utils/config";

export const DATE_URL = `${SYSLOGS_API}`